// User profile image utility functions

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL
// When set, images are served from CloudFront (private S3 origin). Falling back
// to the Supabase public URL keeps the app working before the S3 cutover.
const CLOUDFRONT_DOMAIN = import.meta.env.VITE_CLOUDFRONT_DOMAIN
const STORAGE_BUCKET = 'user-profile-images'

/** Build a public URL for a stored object key, provider-aware. */
function objectUrl(bucket: string, path: string): string {
  if (CLOUDFRONT_DOMAIN) {
    return `https://${CLOUDFRONT_DOMAIN}/${bucket}/${path}`
  }
  return `${SUPABASE_URL}/storage/v1/object/public/${bucket}/${path}`
}

/**
 * Get public URL for user profile image
 */
export function getUserProfileUrl(path?: string): string {
  if (!path) return ''
  return objectUrl(STORAGE_BUCKET, path)
}

/**
 * Get public URL for user banner image
 */
export function getUserBannerUrl(path?: string): string {
  if (!path) return ''
  return objectUrl(STORAGE_BUCKET, path)
}
